module.exports = __webpack_public_path__ + "static/img/check_type_2.ec28414a.png";